export const dfamConfig = {
    taxOfficeName: 'Tax Office',
    deliveryTaxOfficeQuestionTag: 'GOV',
    searchPlaceholder: "Search projects using names or ID numbers...",
    taxId: null,
    atlasId: "Entity ID",
    yearLabel: "Year",
    gtsId: null,
    entityPrimaryName: "Entity Name",
    entitySecondaryName: "Additional Names",
    entityPrimaryNamePlaceholder: "Entity Name",
    entitySecondaryNamePlaceholder: "",
    clientAlias: "Client",
    populationAlias: "Population",
    taxpayerAlias: "Project",
    taxReturnAlias: "Project Form",
    taxpayerAliasPath: "projects",
    taxReturnAliasPath: "project-forms"
};
